import type { CSSProperties } from "react";

import { Badge, Flex } from "metabase/ui";

const CATEGORY_BADGE_COLORS = [
  "var(--mb-color-brand)",
  "var(--mb-color-saturated-blue)",
  "var(--mb-color-saturated-green)",
  "var(--mb-color-saturated-purple)",
  "var(--mb-color-saturated-red)",
  "var(--mb-color-saturated-yellow)",
] as const;

const getCategoryBadgeColor = (category: string) => {
  // Deterministic color per category keeps badges consistent across renders
  const hash = (category || "")
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return CATEGORY_BADGE_COLORS[hash % CATEGORY_BADGE_COLORS.length];
};

interface CategoryBadgesDisplayProps {
  categories?: string[];
  className?: string;
  style?: CSSProperties;
}

export const CategoryBadgesDisplay = ({
  categories,
  className,
  style,
}: CategoryBadgesDisplayProps) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <Flex
      align="center"
      gap="sm"
      pos="relative"
      top={2}
      className={className}
      style={style}
    >
      {categories.map((category, index) => {
        const color = getCategoryBadgeColor(category);

        return (
          <Badge
            key={`${category}-${index}`}
            variant="outline"
            px="md"
            py="xs"
            style={{
              marginTop: "5px",
              borderColor: color,
              color,
              textTransform: "none",
            }}
          >
            {category}
          </Badge>
        );
      })}
    </Flex>
  );
};
